const training = [
    {
        id: 1,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Production and Lean Management"
    },
    {
        id: 2,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "5S for Continuous Improvements"
    },
    {
        id: 3,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Six Sigma"
    },
    {
        id: 5,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Waste Management"
    },
    {
        id: 6,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Efficient Production System & Harmonizing Production Capacity with Demand"
    },
    {
        id: 7,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Problem Solving Methodologies"
    },
    {
        id: 8,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Value Stream Mapping"
    },
    {
        id: 9,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Business Process Mapping"
    },
    {
        id: 10,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Sales Team Development"
    },
    {
        id: 11,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Six Sigma Overview"
    },
    {
        id: 12,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Fundamentals: The Foundation of Competitiveness"
    },
    {
        id: 13,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Introduction to Lean Principle/ Lean Production System/ Lean In Office"
    },
    {
        id: 14,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Management: Key to Higher Productivity, Profitability & Customer Satisfaction"
    },
    {
        id: 15,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Implementation of Lean Six Sigma In Apparel Manufacturing"
    },
    {
        id: 16,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Certified Lean Professional/ Certified Lean Practitioner"
    },
    {
        id: 17,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Applied: Innovation Through Continuous Improvement"
    },
    {
        id: 18,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Managing & Sustaining Lean Journey"
    },
    {
        id: 19,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Leveraging Lean Six Sigma Approach for Growth"
    },
    {
        id: 20,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Kaizen Instructor Training"
    },
    {
        id: 21,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Six Sigma Approach for Process Industries"
    },
    {
        id: 22,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Tool Kit"
    },
    {
        id: 23,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Managing for Daily Improvement Training (MDI)"
    },
    {
        id: 24,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean as a Strategy for Improving Operations – Garment Industry"
    },
    {
        id: 25,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Workplace Efficiency & Productivity"
    },
    {
        id: 26,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Leadership (TOT for Lean Practitioner)"
    },
    {
        id: 27,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Workplace Organization through 5S & Visual Management"
    },
    {
        id: 28,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Office 5S & Kaizen"
    },
    {
        id: 29,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "5S for Greater Efficiency at Business and Production Process"
    },
    {
        id: 30,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Kaizen: A Simplified Approach for Operational Excellence/ Unlocking the Human Potential"
    },
    {
        id: 31,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Efficient Production System & Harmonizing Production Capacity with Demand"
    },
    {
        id: 32,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Value Stream Mapping & Example to create a current state Value Stream Mapping"
    },
    {
        id: 33,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Root Cause Analysis and Problem Solving Methodologies & Sustaining on Efficiency"
    },
    {
        id: 34,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Improvement Drive outputs"
    },
    {
        id: 35,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Total Quality Management (TQM)"
    },
    {
        id: 36,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Six Sigma Yellow Belt Training"
    },
    {
        id: 37,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Lean Six Sigma Black Belt Training"
    },
    {
        id: 38,
        img: "https://i.ibb.co/7kbQ8bj/correct.png",
        name: "Six sigma : DMAIC Approach"
    }
]

export default training